import { gql } from 'apollo-angular';
import { TemplateVariant } from '../../entities/template-variant/template-variant';

export const TEMPLATE_VARIANT_QUERY = gql`
query templateVariantQuery(
  $id: UUID, $templateKey: String
)
{
  templateVariant: getTemplateVariant(
    templateVariantId: $id
  )
  {
    id
    name
    htmlCode
    subject
    plainText
    externalId
    isSystem
    isActive
    isDeletable
    attachments{
      fileName
      id
    }
  },
  templateName: getTemplateName(
    templateKey: $templateKey
  ),
  templateType: getTemplateType(
    templateKey: $templateKey
  )


}
`;

export interface TemplateVariantQueryResponse {
  templateVariant: TemplateVariant;
  loading: boolean;
  templateName: string;
  templateType: string;
}
